import script from "./BeitragsEntwicklung.vue?vue&type=script&setup=true&lang=js"
export * from "./BeitragsEntwicklung.vue?vue&type=script&setup=true&lang=js"

import "./BeitragsEntwicklung.vue?vue&type=style&index=0&id=e5c6e074&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5c6e074"]])

export default __exports__